import angular from "angular";

import {
  Calculation,
  Language,
  Translations,
  Objects
} from "@salaxy/core";
import {IrRowsReportConfigGenerator} from "@salaxy/reports";
import { SessionService } from "../../services";
import { ColumnDefinition } from "tabulator-tables";
import {SxyTableOptions} from "../sxy-table/SxyTableController";
import { SxyTableController } from "../sxy-table/SxyTableController";
/**
 * Renders ir rows report for given calculations
 * Uses Tabulator tables.
 */
export class CalcsIrRowsController implements angular.IController {
  /**
   * For NG-dependency injection
   * @ignore
   */
  public static $inject = [
    "$timeout",
    "SessionService"
  ];

  /** The calculations for the report. Todo add Calcs*/
  public calcs: Calculation[];

  /**Selected report language */
  public lang: Language;

  /** Ref to used SxyTable */
  public $sxyTable: SxyTableController;

  private sxyTableConfig: {currentCalc: Calculation | Calculation[], reportLang: Language, config: {options: SxyTableOptions, include: ColumnDefinition[], data: any[]}} = {
    currentCalc: null,
    reportLang: Language.Default,
    config: null
  };

  private renderedLang: string;

  /**
   * Creates a new CalcReportController
   * @ignore
   */
  constructor(
    private $timeout: angular.ITimeoutService,

    private sessionService: SessionService
  ) {
  }

  /**
   * Config for SxyTable
   */
  public get tableConfig(): {options: SxyTableOptions, include: ColumnDefinition[], data: any[]}{
    if(!this.calcs) {
      this.sxyTableConfig = {
        currentCalc: null,
        reportLang: null,
        config: null
      };
    } else {
      const calcs = angular.copy(this.calcs);
      if(!Objects.equal(this.sxyTableConfig.currentCalc, calcs) || this.lang !== this.sxyTableConfig.reportLang) {
        this.sxyTableConfig.currentCalc = calcs;
        this.sxyTableConfig.reportLang = this.lang;
        this.getDefaultLanguage(this.lang).then((lang) => {
          this.lang = lang;
          this.renderedLang = this.lang;
          this.refreshTableConfig();
        });
      }
    }
    return this.sxyTableConfig.config;
  }

  /** Refreshes table config */
  public async refreshTableConfig() {
    const renderingLang = this.lang ?? Language.Fi;
    await Translations.loadLanguage(renderingLang);
    this.sxyTableConfig.config = IrRowsReportConfigGenerator.getConfig(this.calcs, renderingLang);
    await this.$timeout();
    this.$sxyTable.refresh();
  }

  private async getDefaultLanguage(lang: Language): Promise<Language> {
    if (!lang) {
      return this.sessionService.getReportLang();
    }
    return Promise.resolve(lang);
  }
}